import cookie from "js-cookie";
import api from "@/api";

const account = {
  state: {
    defaultPage: "",
    menu: []
  },

  mutations: {
    SET_MENU: (state, data) => {
      console.log(data);
      if (data == null) {
        state.defaultPage = "";
        state.menu = [];
      } else {
        state.defaultPage = data.defaultpage;
        state.menu = data.listmenu;
      }
    }
  },

  actions: {
    Menu({ commit }, employee) {
      return new Promise((resolve, reject) => {
        api.tmh.hr.account
          .searchMenu({
            platform: 1,
            employeecode: employee.employeecode,
            rolecode: employee.rolecode,
            applycode: 3
          })
          .then(res => {
            if (res.data.success) {
              commit("SET_MENU", res.data.result);
            } else {
              commit("SET_MENU", []);
            }
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    Logout({ commit }) {
      cookie.remove("token");
      cookie.remove("employee");
      commit("SET_MENU", null);
    }
  }
};

export default account;



// WEBPACK FOOTER //
// ./src/store/modules/account.js